var map = {
	"./EVCharger.svg": 79291,
	"./EVDevice.svg": 94081,
	"./HVACStorage.svg": 35907,
	"./SimulatedDevice.svg": 33062,
	"./circle-icon.svg": 72791,
	"./cursor-icon.svg": 55153,
	"./customModalClose.svg": 86699,
	"./file.svg": 91779,
	"./house-icon.svg": 95421,
	"./house.svg": 29258,
	"./lightning-bolt.svg": 86802,
	"./mobile.svg": 84881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36075;